import React from 'react';
import styled from 'styled-components';
import Lottie from 'react-lottie';
import defaultLoading from '../../assets/loading.json';
import lightLoading from '../../assets/loading_light.json';

const Wrapper = styled.div`
    pointer-events: none;
`

export const Loading = (props) => {
    
    const defaultOptions = {
        loop: true,
        autoplay: true, 
        animationData: props.light ? lightLoading : defaultLoading,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    }

    return (
        <Wrapper>
            <Lottie options={defaultOptions}
                height={props.height || 100}
                width={props.width || 100}
            />
        </Wrapper>
    )
}